import React, { useState } from 'react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import AlertTitle from '@mui/material/AlertTitle'
import API from '../../services/API'
import { CircularProgress } from '@mui/material'

const EmailNotVerified = ({ email }) => {
  const [sendInProgress, setSendInProgress] = useState(false)
  const [newEmailSent, setNewEmailSent] = useState(false)
  const [sendFailed, setSendFailed] = useState(false)
  const handleResendVerificationEmail = () => {
    setSendInProgress(true)
    API.post('/resend-verification-email', {
      emailAddress: email,
    })
      .then((res) => {
        if (res.status === 200) {
          setNewEmailSent(true)
        } else {
          setSendFailed(true)
        }
      })
      .catch(() => setSendFailed(true))
  }

  return (
    <>
      <Alert severity="error">
        <AlertTitle>Email Address not verified.</AlertTitle>
        <p>
          You have not verified your email address yet. You need to click the
          link in the message you received in order to verify your email
          address.
        </p>
        <p>
          If you cannot find the email we sent you, you can click the button
          below to re-send it. Please check all your folders in your inbox,
          including the spam folder. The email will be sent from
          "no-reply@ambunet.co.uk".
        </p>
        {!newEmailSent && !sendFailed && (
          <Button
            onClick={handleResendVerificationEmail}
            variant="contained"
            size="small"
            endIcon={
              sendInProgress && (
                <CircularProgress size="1rem" sx={{ color: 'white' }} />
              )
            }
          >
            Re-Send Verification Email
          </Button>
        )}
      </Alert>
      {sendFailed && (
        <Alert variant="filled" severity="error">
          Unable to send verification email. Please try again later. Contact
          support@ambunet.co.uk if the problem persists.
        </Alert>
      )}
      {newEmailSent && (
        <Alert variant="filled" severity="success">
          New Email Verification Link Sent
        </Alert>
      )}
    </>
  )
}

export default EmailNotVerified
